import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { dashboardLayoutComponent } from '@/routes/layouts/dashboard-layout-route';
import type { FilterDrawerFormValue } from '@/components/shared/filter-drawer/types';

export const ewalletRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/ewallet',
  component: lazyRouteComponent(() => import('@/pages/ewallet/ewallet-page')),
  validateSearch: (search: Record<string, unknown>): FilterDrawerFormValue => {
    return {
      ...search,
    };
  },
});

export const ewalletkDetailRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/ewallet/$referenceId',
  component: lazyRouteComponent(() => import('@/pages/ewallet/ewallet-detail-page')),
});
